import ctl from "@netlify/classnames-template-literals";

export const loader = ctl(`
  flex  
  w-full
  flex-col
  items-center
  justify-center
`);
